import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { NavLink } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import classnames from 'classnames';
import { injectStyles } from 'injectStyles';
import * as cssVariable from 'cssVariables';
import FaqQuestions from 'components/FaqQuestions';
import FaqSchema from 'components/Schema/faqSchema';

const QUESTIONS_TO_SHOW = 4;
class FaqCategory extends PureComponent {
  static defaultProps = {
    current: null,
    icon: null,
    isError: false,
    isLoading: false,
    questions: null,
    slug: null,
    showAnswers: false,
    showQuestions: false,
    title: null,
    isInContact: false,
  };

  static propTypes = {
    current: PropTypes.string,
    classes: PropTypes.object.isRequired,
    icon: PropTypes.object,
    questions: PropTypes.array,
    title: PropTypes.string,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    showAnswers: PropTypes.bool,
    showQuestions: PropTypes.bool,
    slug: PropTypes.string,
    isInContact: PropTypes.bool,
  };

  render() {
    const {
      classes,
      current,
      icon,
      isLoading,
      isError,
      questions,
      slug,
      showAnswers,
      showQuestions,
      title,
      isInContact,
    } = this.props;

    if (isLoading || isError) {
      return null;
    }
    return questions ? (
      <div
        className={classnames(classes.category, {
          [classes.higherMargin]: showQuestions,
        })}
      >
        {isInContact && <FaqSchema faqs={questions} />}
        <NavLink
          className={classnames(classes.link, {
            [classes.active]: current === slug,
          })}
          to={`/veelgestelde-vragen/${slug}`}
          aria-label={`Ga naar ${title}`}
        >
          {icon && icon.url && (
            <div
              className={classnames(classes.icon, {
                [classes.active]: current === slug,
                [classes.hasQuestions]: showQuestions,
              })}
            >
              <SVG src={icon.url} />
            </div>
          )}
          <span className={classes.title}>{title}</span>
        </NavLink>
        {showQuestions && questions && (
          <FaqQuestions
            categorySlug={slug}
            questions={questions.slice(0, QUESTIONS_TO_SHOW)}
            hasMoreButton={questions.length > QUESTIONS_TO_SHOW && !showAnswers}
            showAnswers={showAnswers}
          />
        )}
      </div>
    ) : null;
  }
}

const styles = (theme) => ({
  categories: {
    marginTop: 20,
  },
  category: {
    marginBottom: 15,
  },
  higherMargin: {
    marginBottom: 45,
  },
  link: {
    fontSize: 18,
    lineHeight: '40px',
    fontWeight: cssVariable.fontWeights.bold,
    color: theme.palette.text.primary,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    textTransform: 'uppercase',
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.navigation.highlight,
    },
    '&:hover $icon:not($hasQuestions)': {
      color: theme.palette.navigation.highlight,
    },
  },
  icon: {
    width: 40,
    height: 40,
    marginRight: 20,
    color: cssVariable.grey500,
  },
  hasQuestions: {
    color: cssVariable.green500,
    flex: '0 0 100%',
  },
  active: {
    color: theme.palette.navigation.highlight,
  },
  title: {
    flex: 1,
  },
});

export default injectStyles(styles)(FaqCategory);
